<!-- Copyright © 2023 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and -->
<!-- matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, -->
<!-- including without limitation, material generated from the software programs which are displayed on the screen such -->
<!-- as icons, screen display looks, etc. -->

<h2>Generic UI Components</h2>

<form>
  <div style="width: 20%">
    <div class="cb">
      <xrx-select
        label="SDE_LANGUAGE"
        id="languages"
        [list]="list"
        property="ISOCode"
        localize="SDE_KEY"
        [(selectedItem)]="selectedItem"
        orderby="languageName"></xrx-select>
    </div>
    <div class="cb">
      <xrx-select
        label="Glyphs"
        id="glyphs"
        [list]="glyphslist"
        property="value"
        localize="value"
        [(selectedItem)]="selectedGlyph"
        orderby="value"></xrx-select>
    </div>
    <!--<xrx-select label="Glyphs" id="glyphs" [list]="glyphslist" property="value" localize="SDE_KEY" [(selectedItem)]="selectedGlyph" (change)="listChange($event)"></xrx-select>-->
  </div>

  <div style="width: 22%">
    <div class="cb">
      <xrx-select
        type="group"
        label="Option Group"
        id="group"
        [list]="optionGrouplist"
        property="value"
        localize="SDE_KEY"
        [(selectedItem)]="itemSelected"></xrx-select>
    </div>
    <div class="cb">
      <xrx-select
        type="group"
        label="Divider"
        id="divider"
        [list]="dividerlist"
        property="value"
        localize="SDE_KEY"
        [(selectedItem)]="itemSelectedd"></xrx-select>
    </div>
    <div class="cb">
      <xrx-select
        label="Invalid"
        inlineLabel="Select Something"
        id="invalid"
        [list]="list"
        property="ISOCode"
        localize="SDE_KEY"
        [(selectedItem)]="selectedInvalid"
        [required]="true"></xrx-select>
    </div>
  </div>

  <div class="cb" style="margin-top: 20px">
    <button type="button" class="xrx-btn btn-secondary" (click)="update()">
      <span class="btn-label">Update List</span></button
    >&nbsp;

    <button type="submit" class="xrx-btn btn-secondary">
      <span class="btn-label">Submit</span>
    </button>
  </div>
</form>

<div class="cb" style="width: 70%; margin-top: 20px">
  <xrx-multi-select
    id="multi"
    title="Multi Select"
    [(list)]="multiSelectList"
    localize="SDE_KEY"></xrx-multi-select>

  <!--<xrx-multi-select id="multi" title="Multi Select" [(list)]="multiSelectList" localize="SDE_KEY" (change)="listChange($event)"></xrx-multi-select>-->
</div>

<div class="cb" style="margin-top: 20px">
  <xrx-radio
    id="radio"
    [list]="radioList"
    property="value"
    localize="value"
    [(checkedItem)]="selectedRadio"></xrx-radio>
</div>

<div class="cb" style="width: 50%; margin-top: 20px">
  <span [textContent]="selectedItem.languageName"></span><br />
  <span [textContent]="selectedGlyph.value"></span><br />
  <span [textContent]="itemSelected.value"></span><br />
  <span [textContent]="itemSelectedd.value"></span><br />
  @if (selectedInvalid) {
    <span [textContent]="selectedInvalid.languageName"></span>
  }
  <br />
  <span>{{ multiSelectList.length }} {{ multiSelectList[0].checked }}</span
  ><br />
  <span [textContent]="selectedRadio.value"></span>
</div>
